// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginWithPassword-module__modalOverlay___DQgjr {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .LoginWithPassword-module__modalContainer___dEWcS {
    background: white;
    width: 360px;
    padding: 20px;
    border-radius: 8px;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }
  
  .LoginWithPassword-module__modalHeader___IKdaL {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .LoginWithPassword-module__closeBtn___Ssf05 {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  
  .LoginWithPassword-module__subText___yS2D_ {
    font-size: 14px;
    color: #555;
    margin: 8px 0 16px;
  }
  
  .LoginWithPassword-module__form___iIc6P {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .LoginWithPassword-module__inputGroup___D27HN {
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .LoginWithPassword-module__icon___VxYxV {
    position: absolute;
    left: 10px;
    color: #777;
  }
  
  .LoginWithPassword-module__input___fIo46 {
    width: 100%;
    padding: 10px 10px 10px 35px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
  }
  
  .LoginWithPassword-module__eyeBtn___PH9YZ {
    position: absolute;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  .LoginWithPassword-module__forgotPassword___q0iM9 {
    color: green;
    background: none;
    border: none;
    font-size: 14px;
    cursor: pointer;
    align-self: flex-start;
  }
  
  .LoginWithPassword-module__loginBtn___RRfi1 {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
  }
  
  .LoginWithPassword-module__loginWithOtp___orvnq {
    background: none;
    border: none;
    color: green;
    font-size: 14px;
    cursor: pointer;
  }
  
  .LoginWithPassword-module__error___k0b3Q{
    color: red;
    font-size: 12px;
  }
  `, "",{"version":3,"sources":["webpack://./src/modals/loginwithpassword/LoginWithPassword.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB","sourcesContent":[".modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modalContainer {\n    background: white;\n    width: 360px;\n    padding: 20px;\n    border-radius: 8px;\n    position: relative;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .modalHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .closeBtn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n  }\n  \n  .subText {\n    font-size: 14px;\n    color: #555;\n    margin: 8px 0 16px;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .inputGroup {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  \n  .icon {\n    position: absolute;\n    left: 10px;\n    color: #777;\n  }\n  \n  .input {\n    width: 100%;\n    padding: 10px 10px 10px 35px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 14px;\n  }\n  \n  .eyeBtn {\n    position: absolute;\n    right: 10px;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .forgotPassword {\n    color: green;\n    background: none;\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n    align-self: flex-start;\n  }\n  \n  .loginBtn {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: bold;\n    font-size: 14px;\n  }\n  \n  .loginWithOtp {\n    background: none;\n    border: none;\n    color: green;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  \n  .error{\n    color: red;\n    font-size: 12px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `LoginWithPassword-module__modalOverlay___DQgjr`,
	"modalContainer": `LoginWithPassword-module__modalContainer___dEWcS`,
	"modalHeader": `LoginWithPassword-module__modalHeader___IKdaL`,
	"closeBtn": `LoginWithPassword-module__closeBtn___Ssf05`,
	"subText": `LoginWithPassword-module__subText___yS2D_`,
	"form": `LoginWithPassword-module__form___iIc6P`,
	"inputGroup": `LoginWithPassword-module__inputGroup___D27HN`,
	"icon": `LoginWithPassword-module__icon___VxYxV`,
	"input": `LoginWithPassword-module__input___fIo46`,
	"eyeBtn": `LoginWithPassword-module__eyeBtn___PH9YZ`,
	"forgotPassword": `LoginWithPassword-module__forgotPassword___q0iM9`,
	"loginBtn": `LoginWithPassword-module__loginBtn___RRfi1`,
	"loginWithOtp": `LoginWithPassword-module__loginWithOtp___orvnq`,
	"error": `LoginWithPassword-module__error___k0b3Q`
};
export default ___CSS_LOADER_EXPORT___;
